<script setup>
import { computed } from 'vue';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  itemType: {
    type: String,
    default: 'product',
    validator: value => ['product', 'service'].includes(value),
  },
});

const emit = defineEmits(['click']);

const typeKey = computed(() =>
  props.itemType === 'service' ? 'SERVICES' : 'PRODUCTS'
);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <EmptyStateLayout
    :title="$t(`CAPTAIN.CATALOG_ITEMS.${typeKey}.EMPTY_STATE.TITLE`)"
    :subtitle="$t(`CAPTAIN.CATALOG_ITEMS.${typeKey}.EMPTY_STATE.SUBTITLE`)"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="min-h-[600px]" />
    </template>
    <template #actions>
      <Button
        :label="$t(`CAPTAIN.CATALOG_ITEMS.${typeKey}.ADD_NEW`)"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
